(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kmk-language-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    const form = document.getElementById('KMKLanguageForm');
    if (!form || form.dataset.kmkLanguageBound) return;
    form.dataset.kmkLanguageBound = 'true';
    form.addEventListener('submit', (event) => {
      const button = event.submitter || document.activeElement;
      const language = button && button.name === 'language_code' ? button.value : '';
      if (language !== 'fr' && language !== 'en') return;
      try {
        document.cookie = 'kmk_language=' + language + '; Path=/; Max-Age=31536000; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '');
      } catch (_) {}
      const location = window.location;
      const path = location.pathname.replace(/^\/en(?=\/|$)/, '') || '/';
      const targetPath = language === 'fr' ? path : '/en' + (path === '/' ? '' : path);
      let returns = form.querySelectorAll('input[name="return_to"]');
      if (!returns.length) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'return_to';
        form.appendChild(input);
        returns = [input];
      }
      returns.forEach((input) => { input.value = targetPath + location.search + location.hash; });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
